module.exports = __webpack_public_path__ + "img/done.0cd524f2.png";